
import { GraduationCap, Briefcase } from "lucide-react";
import { qualificationData } from "@/data/qualificationData";

/**
 * Reduced qualifications section – 
 * cleaner layout, fewer grid items, more whitespace
 */
const QualificationsSection = () => {
  const { formalQualifications, professionalExperience } = qualificationData;

  // Show only the most relevant entries (top 4 each)
  const topQualifications = formalQualifications.slice(0, 4);
  const topExperience = professionalExperience.slice(0, 5);

  return (
    <section className="py-16 md:py-24 bg-background">
      <div className="container max-w-4xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground">
            Beruflicher Hintergrund
          </h2>
          <p className="mt-4 text-muted-foreground max-w-2xl mx-auto">
            Praxiserfahrung und kontinuierliche Weiterbildung in den Bereichen Finanzen, Führung und Coaching.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16">
          {/* Fachliche Grundlagen */}
          <div>
            <h3 className="text-lg font-semibold mb-6 flex items-center text-foreground">
              <GraduationCap className="mr-2 h-5 w-5 text-primary" />
              Fachliche Grundlagen
            </h3>
            <div className="space-y-4">
              {topQualifications.map((item, index) => (
                <div key={index} className="pl-4 border-l-2 border-primary/20">
                  <h4 className="font-medium text-foreground text-sm">{item.title}</h4>
                  <p className="text-muted-foreground text-sm mt-1" dangerouslySetInnerHTML={{ __html: item.description.replace(/\*\*(.*?)\*\*/g, '<span class="font-serif font-medium text-foreground">$1</span>') }} />
                </div>
              ))}
            </div>
          </div>

          {/* Berufserfahrung */}
          <div>
            <h3 className="text-lg font-semibold mb-6 flex items-center text-foreground">
              <Briefcase className="mr-2 h-5 w-5 text-primary" />
              Berufserfahrung
            </h3>
            <div className="space-y-4">
              {topExperience.map((item, index) => (
                <div key={index} className="pl-4 border-l-2 border-primary/20">
                  <h4 className="font-medium text-foreground text-sm">{item.title}</h4>
                  <p className="text-muted-foreground text-sm mt-1" dangerouslySetInnerHTML={{ __html: item.description.replace(/\*\*(.*?)\*\*/g, '<span class="font-serif font-medium text-foreground">$1</span>') }} />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-sm text-muted-foreground">
            Orientierung an den{" "}
            <a 
              href="https://coachingfederation.org/ethics/code-of-ethics" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-primary hover:underline"
            >
              ethischen Standards der ICF
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default QualificationsSection;
